export const environment = {
      production: true,
      jiraAPI  :  'https://jira.bna.com/rest/api/2/',
       issuer   : 'https://bna.okta.com' ,
    //  issuer   : 'https://dev-38748493.okta.com/oauth2/default',
     //    clientId : '0oau6oxvxn3uWCr0W0x7'    // Security-Vendor-Q
      //  clientId : '0oau6ou8dba5GLa5b0x7',   // Security-Vendor-D
       clientId : '0oau6ou7o322w8xFD0x7'    // Security-Vendor  
};
